<script setup>

import NavButton from '../components/NavButton.vue'
import StandardPresetCard from '../components/StandardPresetCard.vue'
import StandardPresetCallout from '../components/StandardPresetCallout.vue'
import {ref} from "vue";
import {store} from "@/store";

const props = defineProps({
  title: String,
})

const cardState = ref({
  expanded: ''
})
</script>

<template>
    <div class="page__home">
        <h2>{{ props.title }}</h2>
        <div class="row">
            <div class="col-md-6 body-text">
                <slot></slot>
            </div>
            <div class="col-md-6">
                <div class="standard-preset-cards">
                  <StandardPresetCard
                    v-bind:title="'MINIMUM'"
                    v-bind:imageSrc="'/card-graphic-min.svg'"
                    v-bind:type="'min'"
                    v-bind:cardState="cardState"
                    >Covers all your needs, with some left over for fun.</StandardPresetCard>
                  <StandardPresetCard
                    v-bind:title="'MODERATE'"
                    v-bind:type="'mod'"
                    v-bind:cardState="cardState"
                    >More financial security and flexibility.</StandardPresetCard>
                  <StandardPresetCard
                    v-bind:title="'COMFORTABLE'"
                    v-bind:type="'com'"
                    v-bind:cardState="cardState"
                    >More financial freedom and some luxuries.</StandardPresetCard>
                </div>

                <StandardPresetCallout v-bind:type="'min'" v-bind:cardState="cardState">
                  <p>A ‘minimum’ lifestyle covers all your needs, with some left over for fun and social occasions. You could holiday in the UK, eat out about once a month and take part in some affordable leisure activities about twice a week.</p>
                </StandardPresetCallout>
                <StandardPresetCallout v-bind:type="'mod'" v-bind:cardState="cardState">
                  <p>A ‘moderate’ lifestyle provides more financial security and more flexibility. You could have one holiday abroad a year and eat out a few times a month. You’d have the opportunity to enjoy more of the things you want to do.</p>
                </StandardPresetCallout>
                <StandardPresetCallout v-bind:type="'com'" v-bind:cardState="cardState">
                  <p>A ‘comfortable’ lifestyle allows you to be more spontaneous with your money. You could have a subscription to a streaming service, regular beauty treatments and two holidays abroad a year.</p>
                </StandardPresetCallout>

                <div class="nav-bar">
                    <NavButton dir="x" v-on:click="store.formState.modal = 'whatInfo'">What information do I need to have to hand?</NavButton>
                    <NavButton dir=">" v-on:click="store.formState.page = 'customStandard'">Create my own Retirement Living Standard</NavButton>
                </div>
            </div>
        </div>
    </div>
</template>
